import moment from 'moment';
import Order from '@/apis/Order';

export default {
  data() {
    return {
      countdown: '',
      starTime: '', // 开始时间
      endTime: null,
      Inter: null,
      temporaryTime: null,
      iscance:true,
    };
  },
  watch: {
    countdown(val) {
      if (val === '00:00' && this.iscance) {
        this.iscance = false;
        Order.cancelOrder({ id: this.list ? this.list.id : this.detailInfo.id,type:'canceTime' }).then(() => {
          this.$router.replace('/orderDetail');
        });
      }
    },
  },
  methods: {
    /* count() {
      console.log(this.detailInfo);
      const expectTime = moment(+moment(this.detailInfo.create_time)
        .format('x') + 70000)
        .format('YYYY/MM/DD HH:mm:ss');
      const nowTime = +moment(); // 当前时间总的毫秒数
      const inputTime = +new Date(expectTime); // 用户输入时间总的毫秒数
      let times = (inputTime - nowTime) / 1000; // times是剩余时间总的毫秒数
      // // eslint-disable-next-line no-unused-vars,radix
      // let d = parseInt(times / 60 / 60 / 24);
      // d = d < 10 ? `0${d}` : d;
      // // eslint-disable-next-line radix,no-unused-vars
      // let h = parseInt((times / 60 / 60) % 24);
      // h = h < 10 ? `0${h}` : h;
      // // eslint-disable-next-line radix
      // let m = parseInt((times / 60) % 60);
      // m = m < 10 ? `0${m}` : m;
      // // eslint-disable-next-line radix
      // let s = parseInt(times % 60);
      // if (s > 0) {
      //   s = s < 10 ? `0${s}` : s;
      //   this.countdown = `${m}:${s}`;
      // }
      // eslint-disable-next-line consistent-return
      const timer = setInterval(() => {
        // eslint-disable-next-line no-plusplus
        times--;
        // eslint-disable-next-line radix,no-unused-vars
        let d = parseInt(times / 60 / 60 / 24);
        d = d < 10 ? `0${d}` : d;
        // eslint-disable-next-line radix,no-unused-vars
        let h = parseInt((times / 60 / 60) % 24);
        h = h < 10 ? `0${h}` : h;
        // eslint-disable-next-line radix
        let m = parseInt((times / 60) % 60);
        m = m < 10 ? `0${m}` : m;
        // eslint-disable-next-line radix
        let s = parseInt(times % 60);
        if (s > 0) {
          s = s < 10 ? `0${s}` : s;
          this.countdown = `${m}:${s}`;
        }
        if (s === 0) {
          console.log('结束了0s');
          clearInterval(timer);
          this.$router.replace('/orderDetail');
          this.countdown = '00:00';
        }
        if (s < 0) {
          clearInterval(timer);
          this.countdown = '00:00';
        }
      }, 1000);
    }, */
    count(is_ticket) {
      if(is_ticket == 1){
        this.countdown = '04:59'
      }else{
        this.countdown='09:59'
      }
      this.starTime = this.detailInfo && this.detailInfo.create_time;

      if(is_ticket == 1){
        this.endTime = moment(+moment(this.detailInfo ? this.detailInfo.ticket_time : this.list.ticket_time)
        .format('x') ); // 设置一个后的时间

      }else{
        this.endTime = moment(+moment(this.detailInfo ? this.detailInfo.create_time : this.list.create_time)
        .format('x') + 601000); // 设置一个10分钟后的时间

      }
      console.log( this.endTime)
    

      this.temporaryTime = this.endTime; // 设置一个临时时间
      // document.querySelector('#clock').innerHTML = that.counTime;
      this.Inter = setInterval(() => { // 设置计时器，每一秒调用一次
        this.timeArray(this.endTime);
        if (this.countdown === '00:01') {
          clearInterval(this.Inter);
          setTimeout(() => {
            this.countdown = '00:00';
            Order.cancelOrder({ id: this.list ? this.list.id : this.detailInfo.id,type:'canceTime' }).then(() => {
              this.$router.replace('/orderDetail');
            });
          }, 1000);
        }
      }, 1000);
      return this;
    },
    // eslint-disable-next-line consistent-return
    timeArray(time) { // 倒计时数组,外边放置一个定时器就可以实现倒计时
      let diff = moment(time, 'YYYY-MM-DD hh:mm:ss').diff(moment(), 'seconds'); // 对比两个时间差距，获得相差的秒数
      if (diff <= 0) { // 如果两个时间没有差距
        clearInterval(this.Inter); // 清除定时器
        this.countdown = '00:00';
        return '00:00';
      }
      // eslint-disable-next-line radix
      let days = parseInt(diff / (3600 * 24)); // 根据获得的秒数计算有多少天
      diff -= days * 3600 * 24;
      // eslint-disable-next-line radix
      let hour = parseInt(diff / 3600); // 根据获得的秒数计算有多少小时
      diff -= hour * 3600;
      // eslint-disable-next-line radix
      let minute = parseInt(diff / 60); // 根据获得的秒数计算有多少分钟
      let second = diff - 60 * minute;
      days = this.addZero(days);
      hour = this.addZero(hour);
      minute = this.addZero(minute);
      second = this.addZero(second);
      this.countdown = `${minute}:${second}`;
    },
    addZero(val) {
      if (val >= 10) {
        return val;
      }
      return `0${val}`;
    },
  },
};
